interface CountryNamePool {
  firstNames: readonly string[]
  surnames: readonly string[]
}

export const PLAYER_NAME_POOLS: Readonly<Record<string, CountryNamePool>> = {
  España: {
    firstNames: ['Alejandro', 'Hugo', 'Pablo', 'Álvaro', 'Marcos', 'Sergio', 'Adrián', 'Dani', 'Iker', 'Mateo', 'Martín', 'Nico'],
    surnames: ['García', 'Rodríguez', 'Martínez', 'López', 'Sánchez', 'Pérez', 'Gómez', 'Fernández', 'Ruiz', 'Moreno', 'Navarro', 'Romero'],
  },
  Inglaterra: {
    firstNames: ['Jack', 'Harry', 'Oliver', 'George', 'Charlie', 'Jacob', 'Thomas', 'Alfie', 'Mason', 'Lewis', 'Jude', 'Liam'],
    surnames: ['Smith', 'Jones', 'Taylor', 'Brown', 'Wilson', 'Johnson', 'Davies', 'Robinson', 'Wright', 'Thompson', 'Walker', 'White'],
  },
  Italia: {
    firstNames: ['Lorenzo', 'Matteo', 'Alessandro', 'Federico', 'Riccardo', 'Tommaso', 'Marco', 'Luca', 'Davide', 'Simone', 'Andrea', 'Nicolò'],
    surnames: ['Rossi', 'Russo', 'Ferrari', 'Esposito', 'Bianchi', 'Romano', 'Colombo', 'Ricci', 'Marino', 'Greco', 'Gallo', 'Conti'],
  },
  Alemania: {
    firstNames: ['Lukas', 'Leon', 'Jonas', 'Felix', 'Julian', 'Maximilian', 'Niklas', 'Florian', 'Tim', 'Moritz', 'Karim', 'Jamal'],
    surnames: ['Müller', 'Schmidt', 'Schneider', 'Fischer', 'Weber', 'Meyer', 'Wagner', 'Becker', 'Hoffmann', 'Schäfer', 'Koch', 'Bauer'],
  },
  Francia: {
    firstNames: ['Lucas', 'Hugo', 'Enzo', 'Louis', 'Théo', 'Mathis', 'Antoine', 'Rayan', 'Kylian', 'Nolan', 'Yanis', 'Amine'],
    surnames: ['Martin', 'Bernard', 'Thomas', 'Petit', 'Robert', 'Richard', 'Durand', 'Moreau', 'Laurent', 'Simon', 'Michel', 'Leroy'],
  },
  Argentina: {
    firstNames: ['Mateo', 'Santiago', 'Thiago', 'Benjamín', 'Joaquín', 'Lautaro', 'Facundo', 'Franco', 'Valentín', 'Nicolás', 'Tomás', 'Agustín'],
    surnames: ['González', 'Rodríguez', 'Fernández', 'López', 'Martínez', 'Pérez', 'Gómez', 'Sánchez', 'Romero', 'Díaz', 'Álvarez', 'Acosta'],
  },
  Brasil: {
    firstNames: ['João', 'Gabriel', 'Lucas', 'Matheus', 'Pedro', 'Rafael', 'Vinícius', 'Bruno', 'Thiago', 'Caio', 'Guilherme', 'André'],
    surnames: ['Silva', 'Santos', 'Oliveira', 'Souza', 'Pereira', 'Costa', 'Rodrigues', 'Almeida', 'Nascimento', 'Lima', 'Gomes', 'Ribeiro'],
  },
  Uruguay: {
    firstNames: ['Santiago', 'Matías', 'Agustín', 'Facundo', 'Joaquín', 'Federico', 'Nicolás', 'Rodrigo', 'Sebastián', 'Franco', 'Maximiliano', 'Luciano'],
    surnames: ['Rodríguez', 'González', 'Martínez', 'Fernández', 'Pérez', 'García', 'Silva', 'López', 'Pereira', 'Sosa', 'Cabrera', 'Suárez'],
  },
  'Estados Unidos': {
    firstNames: ['Ethan', 'Noah', 'Liam', 'Mason', 'Logan', 'Caleb', 'Aiden', 'Diego', 'Mateo', 'Cameron', 'Tyler', 'Jordan'],
    surnames: ['Johnson', 'Williams', 'Brown', 'Davis', 'Miller', 'Wilson', 'Moore', 'Taylor', 'Anderson', 'Thomas', 'Martinez', 'Robinson'],
  },
  'Arabia Saudí': {
    firstNames: ['Abdullah', 'Mohammed', 'Fahad', 'Salem', 'Yasser', 'Saud', 'Khalid', 'Nawaf', 'Sultan', 'Hassan', 'Firas', 'Ayman'],
    surnames: ['Al-Dawsari', 'Al-Shehri', 'Al-Qahtani', 'Al-Harbi', 'Al-Ghamdi', 'Al-Otaibi', 'Al-Shammari', 'Al-Yami', 'Al-Mutairi', 'Al-Faraj', 'Al-Bishi', 'Al-Abed'],
  },
}

function pick<T>(values: readonly T[], random: () => number): T {
  const index = Math.min(values.length - 1, Math.max(0, Math.floor(random() * values.length)))
  return values[index]!
}

export function generatePlayerName(country: string, random: () => number = Math.random): string {
  const pool = PLAYER_NAME_POOLS[country] ?? PLAYER_NAME_POOLS.España!
  return `${pick(pool.firstNames, random)} ${pick(pool.surnames, random)}`
}
